import React, { useEffect, useState } from "react";
import "./Category_Slider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
const Category_Slider = ({
  setSubCategoryId,
  subCategoryId,
  categories,
  categoryName,
  categoryImage,
  ...props
}) => {
  // useEffect(() => {
  //   console.log(props.categoryId, 'props.categoryId');

  // }, [props.categoryId]);

  // const setCategoryID = async (id) => {
  //     props?.setCategoryId(id);
  // }

  return (
    <>
      <section className="All_Vegitables_category">
        <div className="slidersec">
          <Swiper
            modules={[Navigation]}
            navigation={true}
            breakpoints={{
              0: { slidesPerView: 2, spaceBetween: 10 },
              350: { slidesPerView: 2.5, spaceBetween: 10 },
              575: { slidesPerView: 5, spaceBetween: 10 },
              768: { slidesPerView: 6, spaceBetween: 10 },
              991: { slidesPerView: 8, spaceBetween: 10 },
              1200: { slidesPerView: 9, spaceBetween: 10 },
              1400: { slidesPerView: 10, spaceBetween: 20 },
              1600: { slidesPerView: 7.5, spaceBetween: 20 },
            }}
            className="mySwiper Category_Slider category_slider "
          >
            <SwiperSlide
              key={"all"}
              onClick={() => {
                // setActiveIndex(0);
                setSubCategoryId(null);
              }}
            >
              <div className={`sliderdiv ${!subCategoryId ? "active" : ""}`}>
                <div className={`imagediv ${!subCategoryId ? "active" : ""}`}>
                  <div className="img_holder">

                  <img
                    className="slider-img"
                    src={
                      categoryImage
                        ? process.env.REACT_APP_IMG_URL + categoryImage
                        : process.env.PUBLIC_URL +
                          "/assets/images/cats/cat1.png"
                    }
                    // src={
                    //   process.env.PUBLIC_URL + resto_category_slider[0]?.image
                    // }
                    alt="All Products"
                  />
                  </div>
                <p className="catname">{categoryName || "All Products"}</p>
                </div>
              </div>
            </SwiperSlide>

            {categories?.map((data, idx) => {
              return (
                <SwiperSlide
                  key={data?.id}
                  onClick={() => {
                    setSubCategoryId(data?.id);
                  }}
                >
                  <div
                    className={`sliderdiv ${
                      subCategoryId === data?.id ? "active" : ""
                    }`}
                  >
                    <div className={`imagediv active`}>
                      <div className="img_holder">
                        <img
                          className="slider-img"
                          src={process.env.REACT_APP_IMG_URL + data?.image}
                          alt={data?.name}
                        />
                      </div>
                    <p className="catname">{data?.name}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default Category_Slider;
